import toString from './toString';

const toUsageString = toString.with({
  YesNo: (question, positive, child) => (child ? child : ''),
  OneOf: (label, options, answer) => (answer ? `${answer.label}${answer.child ? ` (${answer.child})` : ''}` : null),
});

export default toUsageString;
